<div>
    <div class="clearfix">
        <p class="title fl">我的积分</p>
    </div>
    <div class="p-points-content clearfix">
        <div class="pointsAvail-info fl">
            {{if CanUseScore}}
                可用积分：{{CanUseScore}}
            {{else}}
                可用积分：0
            {{/if}}
        </div>
        <a class="w130btn getpoints-btn fr">去赚取积分</a>
    </div>
    <div class="clearfix mb20">
        <p class="title fl">积分明细</p>
    </div>
    <div class="points-detail-list">
        {{if ScoreChangeList.length}}
            {{each ScoreChangeList item }}
                <div class="points-detail-item clearfix">
                <dl class="fl">
                    <dt>{{item.TypeName}}</dt>
                    <dd>{{item.AddTime}}</dd>
                </dl>
                {{if item.Score>0}}
                    <h4 class="fr" style="color: #FF5379">{{item.Score}}</h4>
                {{else}}
                    <h4 class="fr" style="color: #333">{{item.Score}}</h4>
                {{/if}}
            </div>
            {{/each}}
        {{else}}
            无记录
        {{/if}}
    </div>
</div>